export const ALL_MODELS = 'ALL_MODELS';

export const ALL_MODELS_RUNE = 'ALL_MODELS_RUNE';
